import { Injectable } from '@angular/core';
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from '@angular/router';
import { LoaderService } from '../services/loader.service';

@Injectable({
  providedIn: 'root',
})
export class LoaderInterceptor {
  private navigationTimer?: number;
  private navLoading = false;
  private readonly navDelayMs = 250;

  constructor(
    private router: Router,
    private loaderService: LoaderService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.navLoading = false;
        if (this.navigationTimer) {
          window.clearTimeout(this.navigationTimer);
        }
        this.navigationTimer = window.setTimeout(() => {
          this.navLoading = true;
          this.loaderService.show();
        }, this.navDelayMs);
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        if (this.navigationTimer) {
          window.clearTimeout(this.navigationTimer);
          this.navigationTimer = undefined;
        }
        if (this.navLoading) {
          this.navLoading = false;
          this.loaderService.hide();
        }
      }
    });
  }
}
